import { useState } from "react";
import instance from "../../Interceptor/api_instance";
import { EditReservation } from "../../Routes/Reservations/ReservationConfirm";
import { useTranslation } from "react-i18next";
import { Spinner } from "../LoadingAnimations/LoadingAnimations";
import { convertToPST } from "../../Helper/FormatDatetimes";
import { useFetch } from "../../Hooks/useFetch";

const ReservationsGraphic = () => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(null);

  const {
    data: reservations,
    isLoading,
    error,
    refetch,
  } = useFetch(async ({ signal }) => {
    const response = await instance.get("/assets/user-reservations/", {
      signal,
    });
    return response.data;
  });

  return (
    <>
      <div className="graphics-card">
        <h4 className="global-h4 gray">
          {t("graphics-cont.reservations.header")}
        </h4>
        {error && <p className="error">{error}</p>}
        <div className="recent-activity">
          {isLoading ? (
            <Spinner />
          ) : reservations !== "" ? (
            reservations?.map((reservation, index) => (
              <div key={index} className="activity-item">
                <div className="reservation-item-cont">
                  <div>
                    <span className="">Trailer: </span>
                    <span className="global-h5 gray">
                      {reservation.trailer.trailer_number}
                    </span>
                  </div>
                  {reservation.truck_asset && (
                    <div>
                      <span className="">{t("yard-tables.tabs.truck")}: </span>
                      <span className="global-h5 gray">
                        {reservation.truck_asset?.company}-
                        {reservation.truck_asset?.name}
                      </span>
                    </div>
                  )}
                  <div>
                    <span className="">{t("driversTable.columns.name")}: </span>
                    <span className="global-h5 gray">
                      {reservation.user.first_name} {reservation.user.last_name}
                    </span>
                  </div>
                  <div>
                    <span className="">
                      {t("yard-tables.table-columns.datetime")}:{" "}
                    </span>
                    <span className="global-h5 gray">
                      {convertToPST(reservation.due_datetime)}
                    </span>
                  </div>
                </div>
                <button
                  className="all-btn other-btn"
                  onClick={() => setSelected(reservation)}
                >
                  {t("buttons.edit")}
                </button>
              </div>
            ))
          ) : null}
        </div>
      </div>
      {selected && (
        <EditReservation
          reservation_id={selected.id}
          close={() => setSelected(null)}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default ReservationsGraphic;
